import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import FadeIn from './FadeIn';

const STEPS = [
  {
    role: 'user',
    content: "Tomorrow's going to be hot.",
  },
  {
    role: 'assistant',
    content: "I can help with that. Would you like me to create:",
    options: [
      'A cold drinks promotion',
      'An ice cream special',
      'A patio seating announcement',
      'All three?',
    ],
  },
];

export default function ConversationalDemo({ className = '' }) {
  const [step, setStep] = useState(0);
  const [visibleOptions, setVisibleOptions] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    if (step === 0) {
      const t = setTimeout(() => setStep(1), 2000);
      return () => clearTimeout(t);
    }
    if (step === 1 && visibleOptions < STEPS[1].options.length) {
      const t = setTimeout(() => setVisibleOptions((v) => v + 1), 400);
      return () => clearTimeout(t);
    }
    if (step === 1 && visibleOptions >= STEPS[1].options.length && !selectedOption) {
      const t = setTimeout(() => {
        setSelectedOption('All three?');
        setTimeout(() => {
          setStep(0);
          setVisibleOptions(0);
          setSelectedOption(null);
        }, 3000);
      }, 2000);
      return () => clearTimeout(t);
    }
  }, [step, visibleOptions, selectedOption]);

  return (
    <FadeIn className={className}>
      <div className="glass-card-light rounded-2xl p-6 lg:p-8 max-w-2xl mx-auto shadow-xl">
        <div className="flex items-center gap-2 mb-6 pb-4 border-b border-invert-border">
          <div className="w-8 h-8 rounded-full bg-invert-orange flex items-center justify-center text-white text-sm font-bold">
            AI
          </div>
          <span className="text-sm font-semibold text-invert-navy">INVERT Marketing Assistant</span>
        </div>

        <div className="space-y-4 min-h-[280px]">
          <AnimatePresence>
            {step >= 0 && (
              <motion.div
                key="user-msg"
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                className="flex justify-end"
              >
                <div className="bg-invert-navy text-white rounded-2xl rounded-br-md px-5 py-3 max-w-[80%] text-sm lg:text-base">
                  {STEPS[0].content}
                </div>
              </motion.div>
            )}
          </AnimatePresence>

          <AnimatePresence>
            {step >= 1 && (
              <motion.div
                key="assistant-msg"
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                className="flex justify-start"
              >
                <div className="bg-slate-100 text-invert-navy rounded-2xl rounded-bl-md px-5 py-4 max-w-[90%]">
                  <p className="text-sm lg:text-base mb-4">{STEPS[1].content}</p>
                  <div className="flex flex-wrap gap-2">
                    {STEPS[1].options.slice(0, visibleOptions).map((opt) => (
                      <motion.button
                        key={opt}
                        type="button"
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        className={`text-sm px-4 py-2 rounded-full border transition-all ${
                          selectedOption === opt
                            ? 'bg-invert-orange text-white border-invert-orange'
                            : 'bg-white border-invert-border text-invert-navy hover:border-invert-orange hover:text-invert-orange'
                        }`}
                      >
                        {opt}
                      </motion.button>
                    ))}
                  </div>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </FadeIn>
  );
}
